

import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BottomNav from "./components/BottomNav";
import Profile from "./pages/Profile";
import Marketplace from "./pages/Marketplace";
import Academy from "./pages/Academy";
import CourseView from "./pages/CourseView";
import SignUp from "./pages/SignUp";
import SellerPendingApproval from "./components/SellerPendingApproval";
import Admin from "./pages/Admin";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

function WelcomeGate({ onAccess }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === "7777") {
      onAccess();
    } else {
      setError("Invalid access code. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-abiu-green-bg px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full flex flex-col items-center animate-fadeIn">
        <img src="/logo192.png" alt="Abiu Logo" className="h-16 w-16 mb-4 rounded-lg" />
        <h1 className="text-3xl font-bold text-abiu-green-dark mb-2">Welcome to Abiu</h1>
        <p className="text-gray-700 mb-6 text-center">Nigeria's Solar & Energy Marketplace. Enter your access code to continue.</p>
        <form onSubmit={handleSubmit} className="w-full flex flex-col items-center gap-4">
          <input
            type="password"
            placeholder="Access Code"
            className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-abiu-green text-center text-lg"
            value={code}
            onChange={e => { setCode(e.target.value); setError(""); }}
            maxLength={8}
            autoFocus
          />
          <button type="submit" className="w-full bg-abiu-green text-white font-semibold py-2 rounded-lg hover:bg-abiu-green-dark transition text-lg">Enter</button>
          {error && <div className="text-red-500 text-sm mt-2">{error}</div>}
        </form>
        <div className="mt-6 text-xs text-gray-400">&copy; 2025 Abiu. All Rights Reserved</div>
      </div>
    </div>
  );
}

function AppContent() {
  const [access, setAccess] = useState(false);
  const { currentUser, sellerPendingApproval } = useAuth();

  if (!access) {
    return <WelcomeGate onAccess={() => setAccess(true)} />;
  }

  if (!currentUser) {
    return <SignUp onSignUpSuccess={() => {}} />;
  }

  // Show pending approval page for sellers who haven't been approved
  if (sellerPendingApproval) {
    return <SellerPendingApproval />;
  }

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex-1 pb-16 md:pb-0">
          <Routes>
            <Route path="/" element={<Navigate to="/marketplace" replace />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/academy/course/:courseId" element={<CourseView />} />
            <Route path="/admin" element={<Admin />} />
            {/* Catch all other routes and redirect to marketplace */}
            <Route path="*" element={<Navigate to="/marketplace" replace />} />
          </Routes>
        </div>
        <Footer />
        <BottomNav />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
